<template>
  <b-form @submit.prevent>
    <b-form-row>
      <b-form-group label="Nazwa" class="mr-3">
        <b-form-input v-model="filters.name" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group label="Poziom zaawansowania" class="mr-3">
        <b-form-select v-model="filters.languageProficiency" :options="languageProficiencyOptions"></b-form-select>
      </b-form-group>

      <b-form-group class="mt-auto">
        <b-button type="submit" class="mr-3" variant="primary" @click="onSearch">Szukaj</b-button>
        <b-button type="submit" class="mr-3" variant="secondary" @click="clear">Wyczyść</b-button>
      </b-form-group>
    </b-form-row>
  </b-form>
</template>
<script>
export default {
  data() {
    return {
      filters: {
        name: null,
        languageProficiency: null
      },
      languageProficiencyOptions: [
        { value: null, text: "" },
        { value: 0, text: this.$options.filters.languageProficiency(0) },
        { value: 1, text: this.$options.filters.languageProficiency(1) },
        { value: 6, text: this.$options.filters.languageProficiency(6) },
        { value: 2, text: this.$options.filters.languageProficiency(2) },
        { value: 3, text: this.$options.filters.languageProficiency(3) },
        { value: 4, text: this.$options.filters.languageProficiency(4) },
        { value: 5, text: this.$options.filters.languageProficiency(5) }
      ]
    };
  },
  methods: {
    clear() {
      this.filters.domain = null;
      this.filters.title = null;
    },
    onSearch() {
      this.$emit("filters-search", this.filters);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
